import React from 'react';
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';

import { validateEmail } from 'mf-shared/utils/emailValidator';

import AuthField from '../Fields/AuthField';
import Captcha from './Captcha';

const validate = (values: FormField) => {
  const errors: FormErrors<FormField> = {};
  if (!values.email) {
    errors.email = 'The email address is required';
  } else if (!validateEmail(values.email)) {
    errors.email = 'Please enter a valid email address';
  }
  if (!values.captcha) {
    errors.captcha = 'The captcha is not valid';
  }
  return errors;
};

const mapForm = {
  form: 'resendVerificationEmail',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const formConnector = reduxForm<FormField, ResendVerificationEmailFormProps>(
  mapForm
);

interface FormField {
  email: string;
  captcha: string;
}

interface ResendVerificationEmailFormProps {}

type Props = ResendVerificationEmailFormProps &
  InjectedFormProps<FormField, ResendVerificationEmailFormProps>;

class ResendVerificationEmailForm extends React.Component<Props> {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          component={AuthField}
          name="email"
          type="text"
          placeholder={'Email'}
          autoCorrect="off"
          autoCapitalize="off"
          icon="fa fa-envelope-o"
          spellCheck="false"
        />
        <Field component={Captcha} name="captcha" />
        <button type="submit" className="btn btn-primary btn-block">
          Resend
        </button>
      </form>
    );
  }
}

export default formConnector(ResendVerificationEmailForm);
